<template>
    <div class="item">
        <div class="title">
            <div class="left">虫情走势信息</div>
            <div class="right">
                <el-select v-model="badInsect" placeholder="请选择" @change="change">
                    <el-option v-for="(item, index) in datalist" :key="index" :label="item.pestName"
                        :value="item.pestName">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="value">
            <div class="info">
                <div class="left">
                    <img src="../../assets/chongqing/seeTime.png" alt="">
                </div>
                <div class="right">
                    <p>始见期</p>
                    <p>(see times)</p>
                    <p>{{ seeTime }}</p>
                    <!-- <p>20头</p> -->
                </div>
            </div>
            <div class="info">
                <div class="left">
                    <img src="../../assets/chongqing/fastigium.png" alt="">
                </div>
                <div class="right">
                    <p>高峰期</p>
                    <p>(Fastigium)</p>
                    <p>{{ fastigiumTime }}</p>
                    <p>{{ fastigiumNum }}头</p>
                </div>
            </div>
            <div class="info">
                <div class="left">
                    <img src="../../assets/chongqing/end.png" alt="">
                </div>
                <div class="right">
                    <p>终见期</p>
                    <p>(End in period)</p>
                    <p>{{ endTime }}</p>
                    <!-- <p>200头</p> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCQ_tendency } from '../../api/api';
import { formatTime } from '../../utils/index'

export default {
    props: {
        deviceId: {
            type: String
        }
    },
    data() {
        return {
            // 查询参数
            query: {
                deviceId: "19221015606",  //设备id
                beginTime: "",            //开始时间 
                endTime: "",              //结束时间 
            },
            // 害虫列表
            list: [],
            badInsect: "",
            // 数据展示
            datalist: {},
            seeTime: "",         //始见期
            fastigiumTime: "",   //高峰期
            fastigiumNum: "",    //高峰期数量
            endTime: "",         //终见期
        }
    },
    watch: {
        deviceId: {
            deep: true,
            handler(newVal, oldVal) {
                console.log(newVal);
                console.log(oldVal);
                this.query.deviceId = newVal
                this.getData()
            },
        }
    },
    created() {
        // this.getData()
    },
    mounted() {

    },
    methods: {
        // 获取数据
        async getData() {
            let res = await getCQ_tendency({
                ...this.query
            })
            console.log(res, "虫情走势信息");
            if (res.code == 200) {
                this.datalist = res.data
                this.badInsect = res.data[0].pestName
                this.seeTime = formatTime(res.data[0].minDate, 'yyyy-MM-dd')
                this.fastigiumTime = formatTime(res.data[0].minDate, 'yyyy-MM-dd')
                this.endTime = formatTime(res.data[0].minDate, 'yyyy-MM-dd')
                this.fastigiumNum = res.data[0].heightCount
            }
        },
        change(e) {
            this.datalist.forEach(item => {
                if (item.pestName == e) {
                    this.seeTime = formatTime(item.minDate, 'yyyy-MM-dd')
                    this.fastigiumTime = formatTime(item.minDate, 'yyyy-MM-dd')
                    this.endTime = formatTime(item.minDate, 'yyyy-MM-dd')
                    this.fastigiumNum = item.heightCount
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.item {
    padding: 10px 15px 25px 28px;
    margin-bottom: 20px;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.5);

    .title {
        display: flex;
        justify-content: space-between;

        .left {
            font-size: 20px;
            line-height: 30px;
            font-family: SourceHanSansSC-regular;
            margin-bottom: 25px;
        }

    }

    .value {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .info {
            display: flex;
            align-items: center;

            .left {
                >img {
                    width: 60px;
                    height: 60px;
                }
            }

            .right {
                width: 100px;
                text-align: center;

                p {
                    font-size: 14px;
                    line-height: 28px;
                }
            }
        }
    }
}
</style>